import type { DigestListResponse, DigestResponse } from '@brimstone/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export function useDigests() {
  return useQuery({
    queryKey: ['digests'],
    queryFn: () => api<DigestListResponse>('/api/digests'),
  });
}

export function useDigest(weekId: string) {
  return useQuery({
    queryKey: ['digest', weekId],
    queryFn: () => api<DigestResponse>(`/api/digests/${weekId}`),
    retry: false,
  });
}

/** Writes one week's digest again from the stored data. */
export function useRegenerateDigest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (weekId: string) =>
      api<DigestResponse>(`/api/digests/${weekId}/regenerate`, { method: 'POST' }),
    onSuccess: (res) => {
      qc.setQueryData(['digest', res.digest.weekId], res);
      void qc.invalidateQueries({ queryKey: ['digests'] });
    },
  });
}
